import { Link, useLocation } from "react-router-dom";
import documents from "@/data/legalDocuments.json";
export default function LegalFooter() {
  const { pathname } = useLocation();
  if (pathname === "/app" || pathname.startsWith("/app/") || pathname.startsWith("/l/")) return null;
  return <footer className="max-w-6xl mx-auto px-5 py-8 text-xs text-slate-400 border-t border-white/10" data-testid="legal-footer">
    <p className="font-semibold text-slate-200">Nadia Cloud</p>
    <p className="mt-2">Proprietà di NODO AI · P.IVA 05516570289</p>
    <p className="mt-1"><a href="mailto:support@nadiacloud.it" className="hover:text-cyan-200">support@nadiacloud.it</a></p>
    <nav aria-label="Informazioni legali" className="mt-4 flex flex-wrap gap-x-5 gap-y-3">{documents.map(item => <Link key={item.path} to={item.path} className="text-cyan-300 hover:underline">{item.title}</Link>)}</nav>
    <p className="mt-3 text-amber-200/80">Informazioni legali e contatti di Nadia Cloud.</p>
  </footer>;
}
